<template>
  <div id="slideshow" class="flex z4 light">
    <div id="slideshow-header" class="z1 col-12 sm-col-9 border-bottom">
      <div class="flex col-12">
        <div class="p2 col-3 caps">
          <span class="hover-red pointer noselect" @click="$emit('close')">Close</span>
        </div>
        <div class="p2 col-6 center caps text-overflow" v-html="currentImageTitle" />
        <div class="p2 col-3 right-align">{{ parseInt(slideshowIndex) + 1 }} of {{ galleryLength }}</div>
      </div>
      <div class="flex border-top center caps col-12 sm-hide md-hide lg-hide">
        <div class="slideshow-button flex-auto p1 border-right pointer noselect" @click="slideshowPrev">←</div>
        <div class="slideshow-button flex-auto p1 pointer noselect" @click="slideshowNext">→</div>
      </div>
    </div>
    <div
      id="slideshow-left"
      class="slideshow-column col-12 sm-col-9 flex items-center mt3 pointer"
      @click="slideshowNext">
      <img :src="currentImageSrc" />
    </div>
    <div id="slideshow-right" class="slideshow-column col-3 xs-hide z1">
      <div class="flex border-bottom center caps">
        <div class="slideshow-button flex-auto p2 border-right pointer noselect" @click="slideshowPrev">←</div>
        <div class="slideshow-button flex-auto p2 pointer noselect" @click="slideshowNext">→</div>
      </div>
      <div class="m3">
        <h3 v-html="currentImageTitle" />
        <p v-if="currentImageCaption" class="fs-s" v-html="currentImageCaption"></p>
        <!-- <p class="fs-xs caps">&copy; Forensic Architecture, {{ currentYear }}</p> -->
      </div>
      <div class="download col-3 center border-top">
        <a
          :href="currentImageDownloadSrc"
          class="p2 light caps slideshow-button"
          target="_blank">Full Resolution</a>
      </div>
    </div>
    <div id="slideshow-caption-mobile" class="z4 sm-hide md-hide lg-hide" :class="{ 'bg': captionBg }" @click="captionBg = !captionBg">
      <h3 v-html="currentImageTitle" />
      <p v-if="currentImageCaption" class="fs-s" v-html="currentImageCaption"></p>
      <!-- <p class="fs-xs caps">&copy; Forensic Architecture, {{ currentYear }}</p> -->
    </div>
  </div>
</template>

<script>
export default {

  name: 'SlideShow',

  data () {
    return {
      currentYear: (new Date()).getFullYear(),
      captionBg: false
    }
  },

  props: ['index', 'slideshowItems', 'slideshowIndex'],

  mounted () {
    document.addEventListener("keyup", this.slideNav)
  },

  computed: {
    galleryLength () {
      return this.slideshowItems.length
    },
    currentImageCaption () {
      return this.slideshowItems[this.slideshowIndex].caption
    },
    currentImageTitle () {
      return this.slideshowItems[this.slideshowIndex].title
    },
    currentImageSrc () {
      return this.slideshowItems[this.slideshowIndex].full
    },
    currentImageDownloadSrc () {
      return this.slideshowItems[this.slideshowIndex].full
    }
  },

  methods: {
    slideNav () {
      event.stopPropagation()
      if (event.key === "Escape") {
        this.$emit('close')
      } else if (event.key == "ArrowLeft") {
        this.slideshowPrev()
      } else if (event.key == "ArrowRight") {
        this.slideshowNext()
      }
    },
    slideshowNext () {
      let toIndex = 0
      if (parseInt(this.slideshowIndex) === this.galleryLength - 1) {
        toIndex = 0
      } else {
        toIndex = parseInt(this.slideshowIndex) + 1
      }
      this.$emit('open-slideshow-item', toIndex)
    },
    slideshowPrev () {
      let toIndex = 0
      if (parseInt(this.slideshowIndex) === 0) {
        toIndex = this.galleryLength - 1
      } else {
        toIndex = parseInt(this.slideshowIndex) - 1
      }
      this.$emit('open-slideshow-item', toIndex)
    }
  },

  destroyed () {
    document.removeEventListener("keyup", this.slideNav)
  }
}
</script>

<style lang="css" scoped>
  #slideshow {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: blue;
    z-index: 10000;

    .slideshow-column {
      height: 100vh;
    }

    #slideshow-left {
      img {
        margin: 0 auto;
        max-width: 90%;
        max-height: 90%;
      }
      ::selection {
        background: none;
      }
    }

    .slideshow-button {
      &:hover {
        background: white;
        color: blue;
      }
    }

    #slideshow-header {
      position: fixed;
      left: 0;
      background: blue;
    }

    #slideshow-right {
      border-left: 1px solid var(--col-light);
    }

    .download {
      position: fixed;
      bottom: 0;
      right: 0;

      a {
        display: block;
      }
    }
  }

  #slideshow-caption-mobile {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 1em;

    &.bg {
      background: blue;
      border-top: 1px solid var(--col-light);
    }
  }

  @media (--phone) {
    #slideshow {
      #slideshow-left {
        img {
          max-width: 100%;
          padding-bottom: 2.5em;
        }
      }
    }
  }
</style>
